import { useMutation } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'

import { useInvalidateGuestPassProfile } from './get-guest-pass-profile'

interface UpdateGuestPassRequest {
  totalPasses: number
}

const updateGuestPass = async (clientId: string, data: UpdateGuestPassRequest) => {
  const response = await authAPI.put(`/guest-pass/${clientId}`, data)
  return response.data
}

export const useUpdateGuestPass = (clientId: string) => {
  const invalidate = useInvalidateGuestPassProfile()

  return useMutation({
    mutationFn: (data: UpdateGuestPassRequest) => updateGuestPass(clientId, data),
    onSuccess: invalidate,
  })
}
